import React, { useState } from "react";
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image";
// import Img from "gatsby-image"; // to take image data and render it

import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { AnimatedOnScroll } from "react-animated-css-onscroll";

function Services({ opened, language }) {
  const { t } = useTranslation();

  return (
    <section
      id="services"
      className={`${language == "ar" ? "arPartners" : "not"}`}
    >
      <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
        <div className="aboutRightTitle">
          <StaticImage width={20} src="../images/ArrowWhite.svg" alt="arrow" />
          <h1 className="title">{t("servicesTitle")}</h1>
        </div>{" "}
      </AnimatedOnScroll>

      <div className={`${"wholeServices"} ${language == "ar" ? "ar" : ""}`}>
        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage width={150} src="../images/user.svg" alt="Logo" />
            </div>{" "}
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("marketingT")}</h1>
              <p> {t("marketingC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>{" "}
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage
                width={150}
                src="../images/social-media.svg"
                alt="Logo"
              />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("onlineMarketingT")}</h1>
              <p> {t("onlineMarketingC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage
                width={150}
                src="../images/fullMedia.svg"
                alt="Logo"
              />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("journalismT")}</h1>
              <p> {t("journalismC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage
                width={150}
                src="../images/bullhorn.svg"
                alt="Logo"
              />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="1000">
            <div className="servicesDetails">
              <h1>{t("fullJournalismContentT")}</h1>
              <p> {t("fullJournalismContentC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage
                width={150}
                src="../images/illustration.svg"
                alt="Logo"
              />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("designT")}</h1>
              <p> {t("designC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage width={150} src="../images/gift.svg" alt="Logo" />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("giftsT")}</h1>
              <p> {t("giftsC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage width={150} src="../images/print.svg" alt="Logo" />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("printT")}</h1>
              <p> {t("printC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage
                width={150}
                src="../images/fullCode.svg"
                alt="Logo"
              />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("codingT")}</h1>
              <p> {t("codingC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage width={150} src="../images/seo.svg" alt="Logo" />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("seoT")}</h1>
              <p> {t("seoC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage
                width={150}
                src="../images/notebook.svg"
                alt="Logo"
              />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("studyT")}</h1>
              <p> {t("studyC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>

        <div className="singleService">
          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesIcon">
              <StaticImage width={150} src="../images/work.svg" alt="Logo" />
            </div>
          </AnimatedOnScroll>

          <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
            <div className="servicesDetails">
              <h1>{t("trainT")}</h1>
              <p> {t("trainC")} </p>
              {/* <p
                  onClick={() => {
                    opened();
                    localStorage.setItem("content", item.content);
                  }}
                >
                  Read more
                </p> */}
            </div>
          </AnimatedOnScroll>
        </div>
      </div>
    </section>
  );
}

export default Services;
